export const ITEM_STATE_SCHEDULED = 'scheduled';
export const ITEM_STATE_PLAYING = 'playing';
export const ITEM_STATE_PLAYED = 'played';
